<template lang="pug">
.supercharged-entertainment-container
  .page-blank-product-form.book-race
    .book-form
      form(@submit.prevent="submit")
        .book-form__agreement(v-if="hasMultipleTerms")
          h2 I HAVE READ &amp; AGREE WITH ALL SUPERCHARGED TERMS &amp; CONDITIONS
          .other-terms
            agree-to-terms(
              v-for="(term, index) in termsList"
              :key="index"
              :value="termsAgreedList[index]"
              @input="onTermChange(index, $event)"
              :message="term"
              :name="'terms' + index"
            )
        agree-to-terms.book-form__agreement(v-else v-model="termsAgreed")

        include ../../components/global/parts/views/personal-details.pug

        .book-form__add-to-cart
          v-button.site_button.site_button_inverse(:disabled="isAnyInvalid" :loading="isSubmitting")
            span {{ buttonTitle }}
</template>

<script>
import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'
import PersonalDetailsMixins from '../../components/_mixins/personal-details'
import AgreeToTerms from '../../components/parts/AgreeToTerms'

const EventBus = window.VueEventBus

export default {
  name: 'page-blank-product-form',
  settings: 'page.blank-product-form',
  translations: 'page.blank-product-form',
  components: {
    AgreeToTerms,
  },

  mixins: [
    ConfigMixin,
    PagesMixin,
    PersonalDetailsMixins,
  ],

  props: {
    termsAndConditions: {
      type: [Array, String],
      default: () => [],
    },
    buttonTitle: {
      type: String,
      default: 'Continue',
    },
    clickEvent: {
      type: String,
      default: 'blank-product-form-continue',
    },
    redirectRoute: {
      type: String,
      default: 'racewaybooking.checkout',
    },
    redirectUrl: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    personalDetailsStepNumber: 1,
    termsAgreed: 'no',
    termsAgreedList: [],
    isSubmitting: false,

    firstName: null,
    lastName: null,
    phone: null,
    email: null,
  }),

  computed: {
    termsList() {
      if (typeof this.termsAndConditions === 'string') {
        return this.termsAndConditions.split('|').map(term => term.trim()).filter(Boolean)
      }
      return this.termsAndConditions
    },
    hasMultipleTerms() {
      return this.termsList.length > 0
    },
    termsAreAgreed() {
      if (this.hasMultipleTerms) {
        return this.termsAgreedList.length === this.termsList.length &&
          this.termsAgreedList.every(value => value === 'yes')
      }
      return this.termsAgreed === 'yes'
    },
    disabledPersonalDetails() {
      return !this.termsAreAgreed
    },
    isAnyInvalid() {
      return !this.termsAreAgreed || this.$v.personalDetails.$invalid
    },
  },

  created() {
    this.termsAgreedList = this.termsList.map(() => 'no')
    this.$v.$touch()
  },

  methods: {
    onTermChange(index, value) {
      this.$set(this.termsAgreedList, index, value)
    },
    async submit() {
      this.isSubmitting = true
      await EventBus.$$emitAsync(this.clickEvent, {
        first_name: this.firstName,
        last_name: this.lastName,
        phone: this.phone,
        email: this.email,
      })
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
        return
      }
      if (this.redirectRoute) {
        this.$router.push({name: this.redirectRoute})
      }
    },
  },
}
</script>
